import React, { FC, useEffect, useRef } from "react";
import cx from "classnames";
import { createPortal } from "react-dom";
import { Spinner } from "../Spinner/Spinner";

interface Props {
  isOpen?: boolean;
  isBackgroundTransparencyEnabled?: boolean;
}

const portalContainer = document.querySelector("body");

const SplashSpinner: FC<React.PropsWithChildren<Props>> = ({
  isOpen,
  isBackgroundTransparencyEnabled = true,
}) => {
  const element = useRef(document.createElement("div"));

  useEffect(() => {
    (portalContainer as HTMLBodyElement).appendChild(element.current);

    return () => {
      (portalContainer as HTMLBodyElement).removeChild(element.current);
    };
  }, []);

  return createPortal(
    isOpen && (
      <div
        className={cx("fixed left-0 top-0 z-50 h-[100vh] w-[100vw]", {
          "bg-[rgb(255,255,255,0.5)]": isBackgroundTransparencyEnabled,
          "bg-[rgb(255,255,255,1)]": !isBackgroundTransparencyEnabled,
        })}
      >
        <Spinner />
      </div>
    ),
    element.current
  );
};

export default SplashSpinner;
